/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { IUtilityBillData } from '../../../IEnergyManagementProps';
import { EnergyUsageField } from '../../../../shared/Enums';
import ProgressBarWidget from '../../../../shared/ProgressBar/ProgressBarWidget';
import { MAGIC_VALUE } from '../../../../shared/Utils/Constants';

interface IUtilityTabProps {
  data: IUtilityBillData;
  displayBaseline?: boolean;
}

export const SiteUtilityComponent = (props: IUtilityTabProps) => {
  const { data, displayBaseline } = props;

  const {
    utilityCostCurrency,
    totalAggregations: {
      totalActualCost,
      previousPeriodCost,
      totalCostSavingsPercentage,
      totalCostSavings,
      totalActualConsumption,
      previousPeriodConsumption
    }
  } = data;

  const aggregationUtilityData = {
    actual: totalActualCost,
    previousPeriod: previousPeriodCost,
    savings: totalCostSavings,
    savingsPercentage: totalCostSavingsPercentage,
    ActualConsumption: totalActualConsumption,
    previousPeriodConsumption: previousPeriodConsumption
  };

  return (
    <ProgressBarWidget
      utilityCostCurrency={utilityCostCurrency}
      category={EnergyUsageField.UTILITY}
      aggregationData={aggregationUtilityData}
      displayBaseline={displayBaseline}
      toFixedValue={MAGIC_VALUE.TWO}
    />
  );
};
export default SiteUtilityComponent;
